'use client';

import { useEffect, useState } from 'react';
import { Monitor, Sun, Moon } from 'lucide-react';
import { useTheme } from 'next-themes';
import { clsx } from 'clsx';

const OPTIONS = [
  { value: 'system', label: 'System', Icon: Monitor },
  { value: 'light', label: 'Hell', Icon: Sun },
  { value: 'dark', label: 'Dunkel', Icon: Moon },
] as const;

/** 3-Zustand Segmented Control für das Theme (System / Hell / Dunkel). */
export function ThemeToggle({ className }: { className?: string }) {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  // mounted-Guard: vor Hydration kennt der Client das echte Theme nicht →
  // erst nach Mount aktiven Zustand visualisieren (verhindert Mismatch).
  useEffect(() => setMounted(true), []);

  return (
    <div
      role="group"
      aria-label="Farbschema"
      className={clsx(
        'inline-flex items-center gap-0.5 rounded-lg border border-zinc-200 bg-zinc-50 p-0.5',
        className,
      )}
    >
      {OPTIONS.map(({ value, label, Icon }) => {
        const active = mounted && theme === value;
        return (
          <button
            key={value}
            type="button"
            onClick={() => setTheme(value)}
            aria-pressed={active}
            title={label}
            className={clsx(
              'inline-flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-xs font-semibold transition-colors',
              active
                ? 'bg-white text-primary shadow-sm'
                : 'text-text-muted hover:text-secondary',
            )}
          >
            <Icon size={15} aria-hidden="true" />
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
}
